import { render, staticRenderFns } from "./EmailComponent.vue?vue&type=template&id=156d071e&"
import script from "./EmailComponent.vue?vue&type=script&lang=ts&"
export * from "./EmailComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports